import { api } from "../axios";
import { OneTimeTransactionOrderPayload } from "../../types/transaction";

export const createOneTimeTransactionApi = (
  payload: OneTimeTransactionOrderPayload
) => {
  return api.post("mf-purchases/", payload);
};

export const deleteOneTimeTransactionApi = ({
  id,
  investment_account_guid,
}: {
  investment_account_guid: string;
  id: number;
}) => {
  return api.delete(`mf-purchases/${id}/`, {
    data: {
      investment_account_guid,
    },
  });
};

export const updateOneTimeTransactionApi = ({
  id,
  ...payload
}: OneTimeTransactionOrderPayload & { id: number }) => {
  return api.put(`mf-purchases/${id}/`, payload);
};
